import * as Blockly from 'blockly/core';

const restoreCodeFromXml = (textXml, workspace) => {
  const xml = Blockly.utils.xml.textToDom(textXml);

  // Before loading, find any undefined blocks and convert them to error blocks
  const blocks = xml.getElementsByTagName('block');
  for (let i = 0; i < blocks.length; i++) {
    const blockType = blocks[i].getAttribute('type');
    if (!Blockly.Blocks[blockType]) {
      blocks[i].setAttribute('type', 'block_error');
      // Store original type in the label field
      const label = xml.createElement('field');
      label.setAttribute('name', 'TYPE');
      label.textContent = blockType;
      blocks[i].appendChild(label);
    }
  }

  Blockly.Xml.domToWorkspace(xml, workspace);
};

export default restoreCodeFromXml;
